import { ReactNode, memo, MouseEventHandler } from 'react'

export const ExternalLink = memo(function ExternalLink({
  href,
  className = '',
  onClick,
  children,
}: {
  href: string
  className?: string
  onClick?: MouseEventHandler<HTMLAnchorElement> | undefined
  children?: ReactNode
}) {
  return (
    <a
      className={className}
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      onClick={onClick}
    >
      {children}
    </a>
  )
})
